export default __webpack_public_path__ + "static/media/mic_white_48dp.527e2af4.svg";